module.exports = __webpack_public_path__ + "static/media/waveBottom.d8343c3c.svg";